import { useEffect, useState } from "react";
import { Switch } from "@/components/ui/switch";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const Section = ({ title, hint, children, testid }) => (
  <section className="fade-up rounded-2xl border bg-card/70 p-5 sm:p-6" data-testid={testid}>
    <h2 className="font-display text-lg font-semibold tracking-tight">{title}</h2>
    {hint && <p className="mt-1 text-sm text-muted-foreground">{hint}</p>}
    <div className="mt-4 divide-y divide-white/5">{children}</div>
  </section>
);

export const Row = ({ label, hint, children }) => (
  <div className="flex flex-col gap-2 py-3.5 sm:flex-row sm:items-center sm:justify-between sm:gap-6">
    <div className="min-w-0">
      <p className="text-sm font-medium">{label}</p>
      {hint && <p className="mt-0.5 text-xs text-muted-foreground">{hint}</p>}
    </div>
    <div className="flex shrink-0 flex-wrap items-center gap-2">{children}</div>
  </div>
);

export const Toggle = ({ label, hint, checked, onChange, testid }) => (
  <Row label={label} hint={hint}><Switch checked={!!checked} onCheckedChange={onChange} data-testid={testid} /></Row>
);

export const Pick = ({ value, onChange, options, testid, className = "w-48" }) => (
  <Select value={String(value ?? "")} onValueChange={onChange}>
    <SelectTrigger className={className} data-testid={testid}><SelectValue /></SelectTrigger>
    <SelectContent>{options.map((o) => <SelectItem key={o.value} value={String(o.value)}>{o.label}</SelectItem>)}</SelectContent>
  </Select>
);

export const BlurInput = ({ value, onSave, testid, className = "w-48", ...props }) => {
  const [v, setV] = useState(value ?? "");
  useEffect(() => { setV(value ?? ""); }, [value]);
  return <Input {...props} value={v} onChange={(e) => setV(e.target.value)} onBlur={() => String(v) !== String(value ?? "") && onSave(v)} className={className} data-testid={testid} />;
};

export const ColorInput = ({ value, onSave, testid }) => (
  <label className="flex items-center gap-2 rounded-full border px-2 py-1">
    <input type="color" value={value || "#6366f1"} onChange={(e) => onSave(e.target.value)} className="h-6 w-8 cursor-pointer rounded bg-transparent" data-testid={testid} />
    <span className="font-mono text-xs text-muted-foreground">{value}</span>
  </label>
);

export const TestButton = ({ onClick, children, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid} className="h-9 rounded-full border px-4 text-xs font-semibold transition-colors hover:bg-white/5">{children}</button>
);
